import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const BASE_URL = COMMUNITY_ENDPOINTS.REPORTS;

export const list = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/`, { params });

export const markReviewed = (id) =>
  communityHttpClient.post(`${BASE_URL}/${id}/mark_reviewed/`);

export const deleteComment = (id) =>
  communityHttpClient.post(`${BASE_URL}/${id}/delete-comment/`);

export const update = (id, data) =>
  communityHttpClient.patch(`${BASE_URL}/${id}/`, data);

export const summary = () =>
  communityHttpClient.get(`${BASE_URL}/summary/`);

export default {
  list,
  markReviewed,
  deleteComment,
  update,
  summary
};
